export const access = {
  contactEmail: 'hello@queri.law',
  titles: {
    TRIAL_EXPIRED: 'Your free trial has ended',
    TRIAL_TOKEN_LIMIT: 'Your free trial usage is used up',
    ORG_PAUSED: 'Access is paused',
    ORG_CANCELLED: 'Your plan has ended',
    PLAN_ENDED: 'Your plan has ended',
    default: 'No access right now',
  } as Record<string, string>,
  descriptions: {
    TRIAL_EXPIRED: 'Contact us to continue using Queri with your team.',
    TRIAL_TOKEN_LIMIT: 'You have used all the AI usage included in the trial. Contact us to continue.',
    ORG_PAUSED: "Your organization's access to Queri is paused. Contact us or your administrator.",
    ORG_CANCELLED: "Your organization's Queri plan has ended. Contact us to renew it.",
    PLAN_ENDED: "Your organization's Queri plan has ended. Contact us to renew it.",
    default: 'Contact us to continue using Queri.',
  } as Record<string, string>,
  contactUs: 'Contact us',
  copyEmail: 'Copy email address',
  logOut: 'Log out',
  mailSubject: 'Queri access',
  forbidden: {
    title: '403 - Access Denied',
    description:
      "You don't have permission to access this page. This feature is restricted to authorized users.",
    goHome: 'Go Home',
  },
  trial: {
    tokenLimitReached: 'Trial token limit reached',
    ended: 'Trial ended',
    endsToday: 'Trial ends today',
    daysLeft: (days: number) =>
      `${days} day${days !== 1 ? 's' : ''} left on your free trial`,
    tokensUsed: (used: string, limit: string) => `${used} / ${limit} tokens used`,
    upgrade: 'Upgrade',
  },
};

export type AccessDict = typeof access;
